import { render } from "./ShoppingAbout.vue?vue&type=template&id=06c0146a"
import script from "./ShoppingAbout.vue?vue&type=script&lang=js"
export * from "./ShoppingAbout.vue?vue&type=script&lang=js"
script.render = render

export default script